import type { IPositioningBlockProps } from './PositioningBlock'

import { styled } from '@linaria/react'
import { isVariable } from 'utils/helpers'

export const PositioningBlockSC = styled.div<IPositioningBlockProps>`
  position: ${({ position }) => position || 'initial'};
  top: ${({ top }) =>
    isVariable(top) ? `var(${top})` : top ? top : 'initial'};
  z-index: ${({ zIndex }) => zIndex ?? 'initial'};
  background: ${({ backgroundColor }) =>
    backgroundColor ? `var(${backgroundColor})` : 'initial'};
  padding: ${({ paddings }) =>
    paddings && paddings.length > 0
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};
`
